// src/hooks/useHashRoute.ts
import { useCallback, useEffect, useState } from 'react';

/**
 * Реактивный доступ к location.hash с гвардами.
 * Никаких консольных логов. Без сетки.
 */
export function useHashRoute() {
  const [hash, setHash] = useState<string>(() => window.location.hash || '');

  useEffect(() => {
    const onHash = () => setHash(window.location.hash || '');
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  const set = useCallback((value: string) => {
    try {
      if (!value.startsWith('#')) value = `#${value}`;
      if (window.location.hash !== value) window.location.hash = value;
    } catch {
      /* ignore */
    }
  }, []);

  return { hash, set } as const;
}